import {
  AddFundsResultPage,
  LoadingPage,
} from '@resurs-internal/deposits-app-components';
import { useContext } from 'react';
import { useOutletContext } from 'react-router';

import { type ApplicationHandlerProps } from '@/components';
import { CountryContext } from '@/contexts';
import {
  getSectionCount,
  isDevelopment,
  isIntegration,
  sendGTMApplicationFeedback,
  sendGTMApplicationProgress,
} from '@/helpers';
import { useApplication } from '@/hooks';

export const FundsView = () => {
  const { applicationId, product } =
    useOutletContext() as ApplicationHandlerProps;
  const { application, isLoading } = useApplication(applicationId);
  const { country } = useContext(CountryContext);
  const handleGTMProgress = (
    applicationId: string,
    productVariant: string,
    stepName: string,
    stepNumber: number,
  ) => {
    sendGTMApplicationProgress({
      applicationId,
      country,
      productVariant,
      stepName,
      stepNumber,
    });
  };
  const handleGTMFeedback = (
    applicationId: string,
    productVariant: string,
    stars: number,
    feedback: string,
    allowFollowUp: boolean,
  ) => {
    sendGTMApplicationFeedback(
      applicationId,
      productVariant,
      stars,
      feedback,
      allowFollowUp,
      country,
    );
  };

  if (isLoading) {
    return <LoadingPage country={country} />;
  }

  return (
    <AddFundsResultPage
      applicationId={applicationId}
      country={country}
      isDevelopment={isDevelopment}
      isIntegration={isIntegration}
      productName={product.name}
      section={getSectionCount(country, application.productType) - 1}
      sendGTMApplicationFeedback={handleGTMFeedback}
      sendGTMApplicationProgress={handleGTMProgress}
    />
  );
};
